import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";

export const LIST_ADMIN_USERS_FAIL = "ADMIN-USER:LIST_USERS_FAIL";

export interface ListAdminUsersFailAction extends Action {
  type: typeof LIST_ADMIN_USERS_FAIL;
  organization: OrganizationKeyName;
}

export const listAdminUsersFailAction = (
  organization: OrganizationKeyName
): ListAdminUsersFailAction => ({
  type: LIST_ADMIN_USERS_FAIL,
  organization,
});
